module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100 mt4"
  }, [(_vm.isApplied) ? _c('div', {
    staticClass: "f7 inter flex flex-row items-center common applied tl"
  }, [_c('red-tick-icon', {
    staticClass: "mr3"
  }), _vm._v("\n    5% " + _vm._s(_vm.isPhoneOnly ? 'Multi-Plan' : 'Family Plan') + " Discount Applied\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30aed523","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/multiplePhonePlan/summaryBox/DiscountMessage.vue
// module id = 699
// module chunks = 0